import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./../locales/en/translation.json";
import translationES from "./../locales/es/translation.json";
import translationZHCN from "./../locales/zh-CN/translation.json";
import translationDE from "./../locales/de/translation.json";
import translationFR from "./../locales/fr/translation.json";
import translationJA from "./../locales/ja/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      es: { translation: translationES },
      "zh-CN": { translation: translationZHCN },
      de: { translation: translationDE },
      fr: { translation: translationFR },
      ja: { translation: translationJA },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      // Optional: improve language detection
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
